import { PWAInstallElement } from '@khmyznikov/pwa-install'
import { create } from 'zustand'

export type PWAStore = {
  installerRef: React.RefObject<PWAInstallElement>
  isLoading: boolean
  setInstallerRef: (ref: React.RefObject<PWAInstallElement>) => void
  setIsLoading: (loading: boolean) => void
}

const usePWAStore = create<PWAStore>()((set) => ({
  installerRef: { current: null },
  isLoading: true,
  setInstallerRef: (ref) => set({ installerRef: ref }),
  setIsLoading: (loading) => set({ isLoading: loading }),
}))

export default usePWAStore
